import { SvgIcon, SvgIconProps } from '@mui/material';

function TotalEnergySVG(props: SvgIconProps) {
  return (
    <SvgIcon {...props}>
      <mask id="path-1-inside-1_610_155" fill="white">
        <rect x="5.54688" y="4.65894" width="12" height="16.56" rx="0.87962" />
      </mask>
      <rect
        x="5.54688"
        y="4.65894"
        width="12"
        height="16.56"
        rx="0.87962"
        stroke="#0173C8"
        strokeWidth="2"
        mask="url(#path-1-inside-1_610_155)"
      />
      <rect
        width="5.14286"
        height="1.44"
        transform="matrix(1 0 0 -1 8.97559 4.65894)"
        fill="#0173C8"
      />
      <path
        d="M13.1711 8L8.59961 14.0655H10.9683L10.0282 18L14.5996 11.9345H12.2315L13.1711 8Z"
        fill="#0173C8"
      />
    </SvgIcon>
  );
}

export default TotalEnergySVG;
